import { APP_PERMISSIONS } from '@exam-management/permissions';
import { QSetListPaperSection } from '@exam-management/qset-list';
import { Flex } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function QSetListPage() {
  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.EXAM.QSET.VIEW]}>
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          width: '100%',
          height: '100dvh',
          bgcolor: theme.palette.grey[50],
          p: theme.spacing(6),
        })}
      >
        <QSetListPaperSection />
      </Flex>
    </PermissionGuard>
  );
}
